export const currencyCodeMap: Record<string, string> = {
    GBP: 'United Kingdom',
    EUR: 'Europe',
    USD: 'United States',
  };